/***
*
*   APP LAYOUT
*   The mission control dashboard layout containing the navigation
*   and header (title, secondary nav)
*
*   PROPS
*   title: title of the view
*
**********/

import { Fragment, useState, useCallback, useEffect } from 'react';
import { Header } from 'components/lib';
import { Sidebar } from './Sidebar';
import Style from './app.module.scss';

export function AppLayout(props){

  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try { return localStorage.getItem('mc_sidebar_collapsed') === 'true'; }
    catch { return false; }
  });
  const handleCollapsedChange = useCallback((collapsed) => {
    setSidebarCollapsed(collapsed);
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty('--sidebar-w', sidebarCollapsed ? '56px' : '240px');
  }, [sidebarCollapsed]);

  return (
    <Fragment>
      <Sidebar
        items={[
          { label: 'Inbox', link: '/support' },
          { label: 'Accounts', link: '/accounts' },
          { label: 'Users', link: '/users' },
          { label: 'Referrals', link: '/referrals' },
          { label: 'Logs', link: '/logs' },
          { label: 'Feedback', link: '/feedback' },
          { label: 'Product Events', link: '/product-events' },
          { label: 'Pro Credits', link: '/credits' },
        ]}
        onCollapsedChange={handleCollapsedChange}
      />

      <main className={ sidebarCollapsed ? Style.appCollapsed : Style.app }>
        <Header title={ props.title } />
        { <props.children {...props.data }/> }
      </main>
    </Fragment>
  );
}
